export default __webpack_public_path__ + "static/media/18.cf925056.jpg";